import type { PublicationChannel, PublicationOutcome } from '@/api/wire';
import type { Level } from '@/ui/meter';
import type { Tone } from '@/ui/primitives';

/** What a project's level means: it is about a person's voice, not a department's changes (ADR-0059). */
export const VOICE_LEVEL: Record<Level, string> = {
  open_loop: 'Open loop — the twin drafts, and the person posts or throws away every piece',
  mixed: 'Mixed loop — earned on the drafts; with a tool to post with, routine pieces could go out unread',
  closed_loop: 'Closed loop — earned on a long run of drafts going out as written',
};

export const CHANNEL_LABEL: Record<PublicationChannel, string> = {
  blog: 'Blog post',
  forum: 'Forum reply',
  social: 'Social post',
  newsletter: 'Newsletter item',
};

export function outcomeChip(outcome: PublicationOutcome): { label: string; tone: Tone } {
  switch (outcome) {
    case 'posted_unchanged':
      return { label: 'POSTED AS DRAFTED', tone: 'accent' };
    case 'posted_edited':
      return { label: 'POSTED WITH EDITS', tone: 'neutral' };
    case 'discarded':
      return { label: 'DISCARDED', tone: 'neutral' };
    default:
      return { label: 'WAITING', tone: 'warning' };
  }
}
